'use strict';

import 'whatwg-fetch';
import aws4 from 'aws4';

let API_SCHEME        = 'https';
let API_HOST_NAME     = process.env.API_HOST_NAME;
let API_URL_BASE_PATH = '/' + process.env.STAGE;

/**
 * Cognitoの認証情報を使ってAPI Gatewayリクエストするための認証情報を取得。
 * API Gatewayの前にCloudFrontを置いているけど、IAMで認証させるためのSign情報は
 * hostの設定とかpathがCloudFrontないバージョンで作られているのがポイントです。
 * @param path
 * @param method
 * @param data
 * @param credentials
 */
function getSignedOptions(path, method, data, credentials){
  // CloudFrontがない前提でサイン情報を作る。pathに/{stage}をつけないといけない
  path = API_URL_BASE_PATH + path;
  return aws4.sign(
    {
      host:    process.env.API_GATEWAY_HOST_NAME, // CloudFrontがない前提でサイン情報を作る
      path:    path,
      method:  method,
      service: 'execute-api',
      region:  process.env.AWS_REGION,
      body:    data ? JSON.stringify(data) : null,
      headers: {
        'Content-Type': 'application/json' // 全部jsonで統一
      }
    },
    {
      accessKeyId:     credentials.accessKeyId,
      secretAccessKey: credentials.secretAccessKey,
      sessionToken:    credentials.sessionToken
    }
  );
}

/**
 * D3用のGETリクエスト作成
 * @param credentials
 * @param path
 * @param query
 * @returns {Promise}
 */
// function getRequestD3(credentials, path, query){
//   let method = 'GET';
//
//   let signedOptions = getSignedOptions(path, method, null, credentials);
//
//   // https://github.com/github/fetch を使ってます
//   return new Promise((resolve, reject)=>{
//     fetch(API_SCHEME + '://' + API_HOST_NAME + path, {
//       method:  method,
//       mode:    'cors',
//       query:   query,
//       headers: signedOptions.headers
//     })
//       .then((response)=>{
//         // JSONなのでjsonをパース
//         return response.json();
//       })
//       .then((jsonData)=>{
//         if(jsonData.status === 'NG'){
//           logger('[getRequestD3] Error: ', jsonData.errorCode, jsonData.message, 'Path: ', path, ', query: ', query);
//           reject(jsonData);
//         }else{
//           resolve(jsonData.body);
//         }
//       })
//       .catch((err)=>{
//         logger('[getRequestD3] Error: ', err, 'Path: ', path, ', query: ', query);
//         reject(err);
//       });
//   });
// }

/**
 * D3用のPOSTリクエスト作成
 * @param credentials
 * @param path
 * @param data
 * @returns {Promise}
 */
function postRequestD3(credentials, path, data){
  let method = 'POST';
  
  let signedOptions = getSignedOptions(path, method, data, credentials);
  let status        = 0;
  
  // https://github.com/github/fetch を使ってます
  return new Promise((resolve, reject)=>{
    fetch(API_SCHEME + '://' + API_HOST_NAME + path, {
      method:  method,
      mode:    'cors',
      body:    data ? JSON.stringify(data) : null,
      headers: signedOptions.headers
    })
      .then((response)=>{
        status = response.status;
        
        // JSONなのでjsonをパース
        return response.json();
      })
      .then((jsonData)=>{
        if(status === 200){
          resolve(jsonData);
        }
        else{
          // 400以外なので
          logger('[postRequestD3] Error: ', jsonData, 'Path: ', path, ', data: ', data);
          reject(jsonData);
        }
      })
      .catch((err)=>{
        logger('[postRequestD3] Error: ', err, 'Path: ', path, ', data: ', data);
        reject(err);
      });
  });
}

export default {
  /**
   * ディスクをスキャンする
   * @param credentials
   * @param imageFileName
   * @param lineUserId
   * @returns {Promise}
   */
  scanDisc(credentials, imageFileName, lineUserId){
    let data = {imageFileName: imageFileName};
    if(lineUserId){
      data.lineUserId = lineUserId;
    }
    return postRequestD3(credentials, '/disc/scan', data);
  },
  
  /**
   * トークンをベースにコンテンツをゲット
   * @param credentials
   * @param token
   * @param lineUserId
   * @returns {Promise}
   */
  getLineContents(credentials, token, lineUserId){
    let data = {
      token: token,
      lineUserId: lineUserId
    };
    
    return postRequestD3(credentials, '/line/contents', data);
  },
  
  /**
   * コンテンツ閲覧用SignedCookie取得
   * @param credentials
   * @param jwt
   * @param contentId
   * @param discDataId
   * @param lotId
   */
  getContentCredential(credentials, jwt, contentId, discDataId, lotId){
    return postRequestD3(credentials, '/content/credential', {jwt, contentId, discDataId, lotId});
  },
  
  /**
   * お問い合わせを送信する
   * @param credentials
   * @param type
   * @param email
   * @param name
   * @param message
   * @returns {Promise}
   */
  sendInquiry(credentials, type, email, name, message){
    return postRequestD3(credentials, '/inquiry', {type, email, name, message});
  },
  
  /**
   * 再生ログを作るのだ
   * @param credentials
   * @param contentId
   * @param discDataId
   * @param lotId
   * @returns {Promise}
   */
  playContent(credentials, contentId, discDataId, lotId){
    return postRequestD3(credentials, '/content/play', {contentId, discDataId, lotId});
  },
  
  /**
   * アンケート回答を送信する
   * @param credentials
   * @param answer
   * @param jwt
   */
  sendAnswer(credentials, answer, jwt){
    return postRequestD3(credentials, '/content/answer', {answer, jwt});
  }
};



// WEBPACK FOOTER //
// ./src/store/api/d3-api.js